






















































import Vue from 'vue';
import { mapGetters } from 'vuex';
import CheckboxBlankOutlineIcon from 'vue-material-design-icons/CheckboxBlankOutline.vue';
import CheckboxMarkedOutlineIcon from 'vue-material-design-icons/CheckboxMarkedOutline.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import pxModal from '@/dex-shared/components/px-modal.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import BoardModel from '@/dex-shared/models/BoardModel';
import BoardSectionModel from '@/dex-shared/models/BoardSectionModel';
import AdminListModel from '../../models/AdminListModel';

export default Vue.extend({
  components: {
    pxButton,
    pxModal,
    pxCard,
    CheckboxBlankOutlineIcon,
    CheckboxMarkedOutlineIcon,
  },

  props: {
    listId: {
      type: Number,
      required: true,
    },
    aggregatorType: {
      type: String,
      required: true,
      validator: (value: string) =>
        [BoardModel.__typename, BoardSectionModel.__typename].includes(value),
    },
  },

  data: function() {
    return {
      excluded: [],
    };
  },

  computed: {
    ...mapGetters({
      listById: 'listById',
      recommendedBoards: 'recommendedBoards',
      recommendedBoardSections: 'recommendedBoardSections',
    }),
    list(): AdminListModel {
      return this.listById(this.listId);
    },
    associationText(): string {
      if (this.aggregatorType === BoardModel.__typename) {
        return 'algum mural?';
      }
      if (this.aggregatorType === BoardSectionModel.__typename) {
        return 'alguma seção?';
      }
      return '';
    },
    recommendations(): any[] {
      if (this.aggregatorType === BoardModel.__typename) {
        return this.recommendedBoards;
      }
      if (this.aggregatorType === BoardSectionModel.__typename) {
        return this.recommendedBoardSections;
      }
      return [];
    },
  },

  created() {
    this.$store.dispatch('PULL_MATERIAL_RECOMMENDATIONS', this.listId);
  },

  methods: {
    createMaterials(confirmation: boolean) {
      if (confirmation) {
        if (this.aggregatorType === BoardModel.__typename) {
          const boardsToAsssociate = this.recommendedBoards.filter(
            (board: any) => !this.excluded.includes(board.id),
          );
          boardsToAsssociate.forEach(board => {
            this.$store.dispatch('ADD_MATERIAL', {
              boardId: board.id,
              listId: this.list.id,
            });
          });
        }
        if (this.aggregatorType === BoardSectionModel.__typename) {
          const boardSectionsToAssociate = this.recommendedBoardSections.filter(
            (boardSection: any) => !this.excluded.includes(boardSection.id),
          );
          boardSectionsToAssociate.forEach(boardSection => {
            this.$store.dispatch('ADD_MATERIAL', {
              boardSectionsId: boardSection.id,
              listId: this.list.id,
            });
          });
        }
      }
      this.$emit('finished');
    },
    dontAdd(id: number) {
      this.excluded.push(id);
    },
    add(id: number) {
      this.excluded = this.excluded.filter(
        (excludedId: number) => excludedId != id,
      );
    },
  },
});
